<div class="header d-flex justify-content-between align-items-center w-100">
  <div class="header-left d-flex gap-1 align-items-center">
    <!-- Lot I (client clinique — item 21) : hamburger mobile, masqué en desktop par CSS -->
    <button class="burger-btn" type="button" (click)="layout.toggle()" aria-label="Ouvrir le menu">
      <span></span><span></span><span></span>
    </button>
    <!-- TASK-03 (AC10) : sur mobile la sidebar est cachée, le logo Collary est affiché ici -->
    <img src="assets/logos/logo-black.png" class="header-logo-mobile" alt="Collary" (click)="router.navigate(['/agency/dash'])" />
    <div class="text-gray header-title">{{ establishment?.name ?? agencyName }}</div>
  </div>
  <div class="header-right d-flex align-items-center gap-2">
    <!-- Correction client (P5) : info-bulle heures à valider (badge + liste), à côté des notifications -->
    <div class="hours-badge-wrapper position-relative" *ngIf="showHoursBadge">
      <div class="badge" *ngIf="pendingSubmissions?.length">
        {{ pendingSubmissions.length > 99 ? "+99" : pendingSubmissions.length }}
      </div>
      <button type="button" class="hours-btn" (click)="toggleSubmissions($event)"
              title="Relevés d'heures à valider">
        <svg-icon src="assets/icons/calender-check-primary.svg"></svg-icon>
      </button>
      <div class="hours-popover" *ngIf="submissionsOpen" (click)="$event.stopPropagation()">
        <div class="hours-popover-head">
          <span>Heures à valider ({{ pendingSubmissions.length }})</span>
          <button type="button" class="btn-link" (click)="goWeeklyHours()">Tout voir</button>
        </div>
        <div class="hours-popover-body">
          <div class="hours-empty" *ngIf="!pendingSubmissions?.length">Aucun relevé en attente de validation.</div>
          <div class="hours-row" *ngFor="let s of pendingSubmissions" (click)="openSubmissionDetail(s)">
            <div class="hours-row-main">
              <span class="hours-ref">{{ s.missionRef }}</span>
              <span class="hours-pro">{{ s.candidatFullname }}</span>
            </div>
            <div class="hours-row-meta">
              <span *ngIf="s.dayCount">{{ s.dayCount }} j</span>
              <button type="button" class="btn-validate" (click)="quickValidateSubmission(s, $event)">
                {{ validatingId === s.missionId ? '…' : 'Valider' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mr-px-20 position-relative">
      <div class="badge" *ngIf="notifNotReaded">
        {{ notifNotReaded > 99 ? "+99" : notifNotReaded }}
      </div>
      <svg-icon (click)="notifNotReaded = 0" [matMenuTriggerFor]="notif" class="notification"
        src="assets/icons/notif.svg"></svg-icon>
      <div>
        <mat-menu #notif="matMenu" class="notification-container">
          <app-notification-panel
            [notifications]="notification"
            (itemClick)="notifClicked($event)"
          ></app-notification-panel>
        </mat-menu>
      </div>
    </div>

    <div>
      <div [matMenuTriggerFor]="userMenu" class="profile-menu d-flex align-items-center gap-2">
        <!--        <img [src]="displayImg(this.user?.image)" class="user-img" alt="user" />-->
        <div>
          <div class="name">{{ displayName }}<span *ngIf="roleLabel" class="email"> · {{ roleLabel }}</span></div>
          <div class="email">{{ user?.email }}</div>
        </div>
        <svg-icon src="assets/icons/chevron-down.svg"></svg-icon>
      </div>
      <mat-menu #userMenu="matMenu">
        <!--        <button mat-menu-item class="" [routerLink]="['/dashboard', 'profile']">-->
        <!--          <svg-icon src="assets/icons/profile.svg"></svg-icon>-->
        <!--          Mon profil-->
        <!--        </button>-->

        <button mat-menu-item (click)="disconnect()">
          <svg-icon src="assets/icons/disconnect.svg"></svg-icon>
          Se déconnecter
        </button>
      </mat-menu>
    </div>
  </div>
</div>